// const originURL = window.location.origin;
// console.log("originURL oprod", originURL);
const ProdConfig = {
  navURL: "https://www.bluecross.com.hk",

  //接口请求的前缀
  baseURL: "https://ap.bluecross.com.hk/MedicalService/api",

  //付款的js    "https://www.bluecross.com.hk/Scripts/payment-gateway-checkout.js", copy from modular
  paymentJs: "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js",

  //  antd Upload组件的上传接口地址
  actionTempUrl:
    "https://ap.bluecross.com.hk/MedicalService/api/VHISLoveYourSelf/SaveF",

  // 文件打开tab预览的baseUrl
  preViewUrl: "https://ap.bluecross.com.hk",

  superAgentURL: "https://superagent.bluecross.com.hk/superagent/",

};

export default ProdConfig;
